import { AppState } from '../../../../app.reducers';
import { Store, select } from '@ngrx/store';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserProfile } from '../../models';
import { getUserProfile } from '../../redux/user.selectors';
import { SubSink } from 'subsink';
import { LoadUserProfileAction } from '../../redux/user.actions';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ApiHelperService } from '../../../../shared';
import { DxFileUploaderComponent } from 'devextreme-angular';
import { ValueChangedEvent } from 'devextreme/ui/file_uploader';

@Component({
  templateUrl: './profile.html',
  standalone: false
})
export class ProfileComponent implements OnInit, OnDestroy, AfterViewInit {

  userProfile: Observable<UserProfile>;

  image: any;
  name: string;
  email: string;
  phone: string;
  joinedOn: Date;
  userProfileForm: UntypedFormGroup;
  feedbackMessages: any[] = [];

  errorMessage: string;

  private subs = new SubSink();

  @ViewChild('fileUpload', { static: true }) fileUpload: ElementRef;
  @ViewChild('dxProfilePhotoUpload', { static: false }) dxProfilePhotoUpload: DxFileUploaderComponent;

  constructor(private apiHelper: ApiHelperService,
    private router: Router,
    private store: Store<AppState>) {
  }

  ngOnInit() {
    this.initForm();

    this.userProfile = this.store.pipe(select(getUserProfile));
    this.subs.sink = this.userProfile
      .subscribe((profile) => {
        this.updateFormValues(profile);
      });
  }

  ngAfterViewInit(): void {

    const token = window.localStorage.getItem('access_token');
    const uploadHeaders = {
      Authorization: `Bearer ${token}`
    };

    if (this.dxProfilePhotoUpload?.instance) {
      this.dxProfilePhotoUpload.instance.option('uploadHeaders', uploadHeaders);
      this.dxProfilePhotoUpload.instance.option({
        maxFileSize: 5000000, //5MB
        allowedFileExtensions: ['.jpg', '.jpeg', '.png'],
        accept: 'image/*',
        uploadUrl: `${this.apiHelper.apiUrl}${this.apiHelper.userServiceUrl}/api/user/profile-photo`,
        uploadHeaders: uploadHeaders
      });
    }
  }

  initForm() {
    this.userProfileForm = new UntypedFormGroup({
      fileUpload: new UntypedFormControl()
    });
  }

  private goToProfile() {
    this.router.navigate(['useraccount/user/profile']);
  }

  onDxUploaded() {
    this.store.dispatch(new LoadUserProfileAction());
    this.goToProfile();
  }

  onDxValueChanged(e: ValueChangedEvent) {
    const file = e.value[0];

    const maxFileSize = this.dxProfilePhotoUpload.instance.option('maxFileSize');
    const allowedFileExtensions = this.dxProfilePhotoUpload.instance.option('allowedFileExtensions');

    const fileExt = `.${file.name.split('.').pop()}`; //Get the file extension      
    if (!allowedFileExtensions.includes(fileExt)) {
      this.errorMessage = `Invalid file type. Allowed types: ${allowedFileExtensions.join(', ')}.`;
    } else if (file.size > maxFileSize) {
      this.errorMessage = 'File is too large.';
    } else {
      this.errorMessage = null;
    }
  }

  updateFormValues(userProfile: UserProfile) {

    if (userProfile == null) {
      return;
    }

    this.name = userProfile.fullName;
    this.phone = userProfile.phone;
    this.joinedOn = userProfile.joinedOn;
    this.email = userProfile.email;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
